export function getRequestIdFromResponse(response) {
    return response.headers && response.headers['request-id'];
}
//# sourceMappingURL=getRequestIdFromResponse.js.map